import React from 'react'
import { ICategory } from '../../core/api/dto/CategoriesObjDto'
import { useGetStationsQuery } from '../../core/api/StationsApi'
import { AppFilterMultiDropdownWithPagination } from '../../components/AppDropdown/AppFilterMultiDropdownWithPagination'
import { useGetCurrentUserQuery } from '../../core/api/UserApi'

interface AppFilterEdgeServersListProps {
  fullWidth?: boolean
}

export const AppFilterEdgeServersList = ({
  fullWidth,
}: AppFilterEdgeServersListProps) => {
  const { data: currentUser } = useGetCurrentUserQuery()
  if (process.env.REACT_APP_TYPE_SERVER === 'MainServer') {
    return (
      <AppFilterMultiDropdownWithPagination<ICategory, keyof ICategory>
        searchParam={'edge_servers'}
        id={'-edge_servers'}
        getterData={useGetStationsQuery}
        extraOptions={{ main_source: currentUser?.userRoles.restaurant.source }}
        propToShowInList={'name'}
        valuePropName={'id'}
        label={'Станция'}
        placeholder={'Выбрать'}
        fullWidth={fullWidth}
      />
    )
  } else {
    return null
  }
}
